module.exports = __webpack_public_path__ + "img/the-five-the-untold-lives-of-the-women-killed-by-jack-the-ripper.1cffc05d.png";